import { ColWrap } from "components/shared/column";
import { paths } from "helpers/paths";
import React from "react";
import { Route, Switch } from "react-router-dom";
import AtiSu from "./atiSu";
import Kontur from "./kontur";
import List from "./list";
import Parcel from "./parcel";

export default function Integration(props) {
    const { location } = props;
    return (
        <div className="page-content">
            <Switch location={location}>
                <ColWrap>
                    <Route path={paths.integration} component={List} />
                    <Route path={paths.integrationItem("parcel")} component={Parcel} />
                    <Route path={paths.integrationItem("atisu")} component={AtiSu} />
                    <Route path={paths.integrationItem("kontur")} component={Kontur} />
                </ColWrap>
            </Switch>
        </div>
    );
}
